import {useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {UserContext} from 'context/UserContext';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AssistantIcon from '@material-ui/icons/Assistant';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        fontSize: '7em',
        color: theme.palette.primary.main,
        marginLeft: '1rem',
    },
    body: {
        marginBottom: '.5em',
    },
    date: {
        fontWeight: 'bold',
        fontFamily: 'monospace',
    },
}));

const ApplicationAwaitingSignature = () => {
    const {applications} = useContext(UserContext);
    const classes = useStyles();
    const history = useHistory();

    const goToSign = () => {
        history.push('/application/sign');
    }

    if (applications?.application_active) {
        return (
            <Card className={classes.root}>
                <CardMedia>
                    <AssistantIcon className={classes.icon} />
                </CardMedia>
                <CardContent>
                    <Typography variant='h6'>
                        Signature Required
                    </Typography>
                    <Typography variant='body1' className={classes.body}>
                        You have an application from&nbsp;
                        <span className={classes.date}>
                            {
                                `${new Date(applications.application_started_dt || null).toLocaleDateString()}`
                            }
                        </span> awaiting your signature.
                    </Typography>
                    <CardActions>
                    <Button
                        fullWidth
                        variant='contained'
                        color='secondary'
                        onClick={goToSign}
                    >
                        Sign to Complete
                    </Button>
                    </CardActions>
                </CardContent>
            </Card>
        );
    }
    return null;
};

export default ApplicationAwaitingSignature;
